window.Products.HomeDecor.DeskMat = function() {};
window.Products.HomeDecor.DeskMat.inherits(window.Products.HomeDecor.HomeDecor);